<template>
  <div class="flex items-center justify-between gap-2">
    <Dropdown
      triggerStyle="p-2 hover:bg-[#F0F1F3] rounded-full"
      :close-on-outside-click="true"
      :closeOnSelect="true"
    >
      <template #trigger>
        <EllipsisVerticalIcon class="text-[#686666] size-5" />
      </template>
      <template #contents>
        <ul>
          <li>
            <a
              :href="`${appURL}/order/${(order_item as DashboardItem).order?.id}/detail?source=new_dashboard`"
              class="px-2 py-2 text-[#292D32] cursor-pointer duration-300 hover:bg-[#F4F4F4] flex items-center justify-between gap-2"
            >
              <span class="flex justify-start gap-2">
                <DocumentIcon class="text-[#292D32] size-5" /> Details
              </span>

              <span
                class="bg-[#ffae00] size-5 flex items-center justify-center leading-4 rounded-full"
                v-if="
                  can('can-resolve-comment') &&
                  currentTab !== 'urgent_action_items' &&
                  (order_item as DashboardItem).unresolved_comments_count > 0
                "
              >
                <p class="leading-none mb-[-1px]">
                  {{ (order_item as DashboardItem).unresolved_comments_count }}
                </p>
              </span>
            </a>
          </li>
          <li
            class="px-2 py-2 text-[hsl(213,10%,18%)] cursor-pointer duration-300 hover:bg-[#F4F4F4] flex items-center justify-start gap-2"
            @click="() => (changeFactoryModal = true)"
            v-if="
              can('change-factory') &&
              (order_item as DashboardItem).factory_id !== null
            "
          >
            <PencilSquareIcon class="text-[#292D32] size-5" /> Edit Factory
          </li>
          <li
            v-if="
              can('download-customer-pdf') &&
              (order_item as DashboardItem).order.additional_fields &&
              (order_item as DashboardItem).order.additional_fields
                .is_manual_order === false
            "
          >
            <a
              :href="`${storage_url}/${(order_item as DashboardItem).order?.design_file}`"
              target="_blank"
              class="px-2 py-2 text-[#292D32] cursor-pointer duration-300 hover:bg-[#F4F4F4] flex items-center justify-start gap-2"
            >
              <DocumentTextIcon class="text-[#292D32] size-5" /> View PDF
            </a>
          </li>
          <li
            v-if="false"
            class="px-2 py-2 text-[#292D32] cursor-pointer duration-300 hover:bg-[#F4F4F4] flex items-center justify-start gap-2"
          >
            <ChatBubbleLeftRightIcon class="text-[#292D32] size-5" /> Quick
            Comment
          </li>
          <li
            @click="provideQuoteModal = true"
            class="px-2 py-2 text-[#292D32] cursor-pointer duration-300 hover:bg-[#F4F4F4] flex items-center justify-start gap-2"
            v-if="
              (currentTab == 'quote_requested_items' &&
                (order_item as DashboardItem).status) == 'quote_requested' &&
              (order_item as DashboardItem).order.admin_salesrep_id == null
            "
          >
            <DocumentCurrencyDollarIcon class="text-[#292D32] size-5" /> Provide
            Quote
          </li>
          <template v-if="can('update-techpack')">
            <li>
              <a
                :href="`${appURL}/edit-techpack/${(order_item as DashboardItem).order?.id}?source=new_dashboard`"
                class="px-2 py-2 text-[#292D32] cursor-pointer duration-300 hover:bg-[#F4F4F4] flex items-center justify-start gap-2"
              >
                <PencilSquareIcon class="text-[#292D32] size-5" />
                Edit Tech Pack
              </a>
            </li>
          </template>
          <li
            v-if="
              currentTab == 'quote_requested_items' &&
              (order_item as DashboardItem).status == 'quote_provided'
            "
            @click="
              notifyCustomerForQuote((order_item as DashboardItem).order_id)
            "
            class="px-2 py-2 text-[#292D32] cursor-pointer duration-300 hover:bg-[#F4F4F4] flex items-center justify-start gap-2"
          >
            <BellAlertIcon class="text-[#292D32] size-5" /> Notify Customer
          </li>
          <li
            v-if="can('delete-order')"
            @click="deleteOrder((order_item as DashboardItem).order.id)"
            class="px-2 py-2 text-[#292D32] cursor-pointer duration-300 hover:bg-[#F4F4F4] flex items-center justify-start gap-2"
          >
            <TrashIcon class="text-[#292D32] size-5" /> Delete order
          </li>
          <li
            class="px-2 py-2 text-[#292D32] cursor-pointer duration-300 hover:bg-[#F4F4F4] flex items-center justify-start gap-2"
            @click="priceBreakdownModal = true"
          >
            <DocumentCurrencyDollarIcon class="size-5" />
            Order Price
            {{
              `${(order_item as DashboardItem)?.order?.additional_fields?.currency?.msrp?.code ?? ""} ` +
              `${(Number((order_item as DashboardItem)?.price_info?.order_item_final_price) || 0).toFixed(2) ?? 0}`
            }}
          </li>
          <li
            class="text-[#292D32] cursor-pointer duration-300 hover:bg-[#F4F4F4] flex items-center justify-start gap-2"
            v-if="can('update-order-urgency')"
          >
            <button class="flex items-center justify-between w-full">
              <Dropdown
                :customClass="'!w-full'"
                triggerStyle="flex w-full items-center justify-between p-2 rounded-lg"
              >
                <template #trigger>
                  Assign Urgency

                  <ChevronRightIcon class="text-[#686666] size-4" />
                </template>

                <template #contents>
                  <ul>
                    <li
                      @click="
                        updateUrgency(
                          'vip',
                          (order_item as DashboardItem).order.id,
                        )
                      "
                      class="flex items-center justify-start gap-2 px-2 py-2 text-center duration-300 border-b border-gray-200 cursor-pointer group hover:bg-green-100"
                    >
                      <p
                        class="flex flex-row items-center justify-between gap-x-4"
                      >
                        <span
                          class="rounded-full bg-green-300 group-hover:bg-green-400 px-[10px] py-[10px]"
                        ></span>
                        <span>VIP</span>
                      </p>
                    </li>
                    <li
                      @click="
                        updateUrgency(
                          'urgent',
                          (order_item as DashboardItem).order.id,
                        )
                      "
                      class="flex items-center justify-start gap-2 px-2 py-2 text-center duration-300 border-b border-gray-200 cursor-pointer group hover:bg-red-100"
                    >
                      <p
                        class="flex flex-row items-center justify-between gap-x-4"
                      >
                        <span
                          class="rounded-full order_cancel group-hover:bg-red-300 px-[10px] py-[10px]"
                        ></span>
                        <span>Urgent</span>
                      </p>
                    </li>
                    <li
                      @click="
                        updateUrgency(
                          'extra_attention',
                          (order_item as DashboardItem).order.id,
                        )
                      "
                      class="flex items-center justify-start gap-2 px-2 py-2 text-center duration-300 border-b border-gray-200 cursor-pointer group hover:bg-blue-100"
                    >
                      <p
                        class="flex flex-row items-center justify-between gap-x-4"
                      >
                        <span
                          class="rounded-full bg-blue-300 group-hover:bg-blue-400 px-[10px] py-[10px]"
                        ></span>
                        <span>Extra Attention</span>
                      </p>
                    </li>
                    <li
                      @click="
                        updateUrgency(
                          null,
                          (order_item as DashboardItem).order.id,
                        )
                      "
                      :class="[
                        (order_item as DashboardItem).order.urgency,
                        {
                          'pointer-events-none opacity-50':
                            (order_item as DashboardItem).order.urgency == null,
                        },
                      ]"
                      class="flex items-center justify-start gap-2 px-2 py-2 text-center duration-300 cursor-pointer group hover:bg-gray-100"
                    >
                      <p
                        class="flex flex-row items-center justify-between gap-x-4"
                      >
                        <span
                          class="rounded-full bg-gray-300 group-hover:bg-gray-400 px-[10px] py-[10px]"
                        ></span>
                        <span>Remove Urgency</span>
                      </p>
                    </li>
                  </ul>
                </template>
              </Dropdown>
            </button>
          </li>
          <template v-if="(order_item as DashboardItem).order.additional_fields && (order_item as DashboardItem).order.additional_fields.is_manual_order === true"></template>
          <template v-else>
            <li
              class="px-2 py-2 text-[#292D32] cursor-pointer duration-300 hover:bg-[#F4F4F4] flex items-center justify-start gap-2"
            >
              <template v-if="app_environment === 'Production'">
                <template v-if="(order_item as DashboardItem).order?.id > 115">
                  <button
                    @click="
                      fetchAndOpenPdf((order_item as DashboardItem).order, 0)
                    "
                    :class="{
                      'pt-0 pb-0 pr-0':
                        (order_item as DashboardItem).techpack_data &&
                        (order_item as DashboardItem).techpack_data.length === 0,
                    }"
                  >
                    Tech Pack pdf
                    <Dropdown
                      v-if="
                        (order_item as DashboardItem).techpack_data &&
                        (order_item as DashboardItem).techpack_data.length > 1
                      "
                      triggerStyle="p-2 rounded-lg"
                    >
                      <template #trigger>
                        <ChevronRightIcon class="text-[#686666] size-4" />
                      </template>
  
                      <template #contents>
                        <ul>
                          <li
                            :key="techpack_data_item.id"
                            @click="
                              fetchAndOpenPdf(
                                (order_item as DashboardItem).order,
                                techpack_data_item_index + 1,
                              )
                            "
                            class="px-2 py-2 text-[#292D32] cursor-pointer duration-300 hover:bg-[#F4F4F4] flex items-center justify-start gap-2"
                            v-for="(
                              techpack_data_item, techpack_data_item_index
                            ) in (order_item as DashboardItem).techpack_data"
                          >
                            Version {{ techpack_data_item_index + 1 }}
                          </li>
                        </ul>
                      </template>
                    </Dropdown>
                  </button>
                </template>
              </template>
              <template v-else class="w-full">
                <button
                  class="flex items-center justify-between w-full"
                  @click="fetchAndOpenPdf((order_item as DashboardItem).order, 0)"
                  :class="{
                    'pt-0 pb-0 pr-0':
                      (order_item as DashboardItem).techpack_data &&
                      (order_item as DashboardItem).techpack_data.length === 0,
                  }"
                >
                  Tech Pack pdf
                  <Dropdown
                    triggerStyle="p-2"
                    v-if="
                      (order_item as DashboardItem).techpack_data &&
                      (order_item as DashboardItem).techpack_data.length > 1
                    "
                  >
                    <template #trigger>
                      <ChevronRightIcon class="text-[#686666] size-4" />
                    </template>
                    <template #contents>
                      <ul>
                        <template
                          v-if="
                            (order_item as DashboardItem).techpack_data &&
                            (order_item as DashboardItem).techpack_data.length >=
                              1
                          "
                        >
                          <li
                            :key="techpack_data_item.id"
                            @click="
                              fetchAndOpenPdf(
                                (order_item as DashboardItem).order,
                                techpack_data_item_index + 1,
                              )
                            "
                            class="px-2 py-2 text-[#292D32] cursor-pointer duration-300 hover:bg-[#F4F4F4] flex items-center justify-start gap-2"
                            v-for="(
                              techpack_data_item, techpack_data_item_index
                            ) in (order_item as DashboardItem).techpack_data"
                          >
                            Version {{ techpack_data_item_index + 1 }}
                          </li>
                        </template>
                      </ul>
                    </template>
                  </Dropdown>
                </button>
              </template>
            </li>
          </template>
        </ul>
      </template>
    </Dropdown>
    <ProvideQuoteModal
      @onQuoteProvided="onFetch(true)"
      v-if="provideQuoteModal"
      :row="order_item"
    />
    <ChangeFactoryDialog
      :currentTab="currentTab"
      @close="onFetch"
      v-if="changeFactoryModal"
      :order_item="order_item"
    />

    <PriceBreakdownModal
      :appUrl="appURL"
      :can="can"
      :order_item="order_item"
      v-if="priceBreakdownModal"
      @close="handlePriceBreakDownModalCloseEvent"
    />
    <CustomTechPackModal
      :order="(order_item as DashboardItem).order"
      v-if="customTechpackModal"
      @close="() => (customTechpackModal = false)"
    />
  </div>
</template>
<script setup lang="ts">
import Dropdown from "@/components/Shared/Dropdown.vue";
import { can, logError, openV2Application } from "@/composables";
import { http } from "@/interceptors/axiosRequestInterceptor";
import { DashboardItem } from "@/models";
import { useMainStore } from "@/store";
import {
  ClipboardDocumentIcon,
  DocumentCurrencyDollarIcon,
} from "@heroicons/vue/24/outline";
import {
  BellAlertIcon,
  ChatBubbleLeftRightIcon,
  ChevronRightIcon,
  DocumentIcon,
  DocumentTextIcon,
  EllipsisVerticalIcon,
  PencilSquareIcon,
  TrashIcon,
} from "@heroicons/vue/24/solid";
import { storeToRefs } from "pinia";
import { ref } from "vue";
import ChangeFactoryDialog from "./Modals/ChangeFactoryModal.vue";
import CustomTechPackModal from "./Modals/CustomTechPackModal.vue";
import PriceBreakdownModal from "./Modals/PriceBreakdownModal.vue";
import ProvideQuoteModal from "./Modals/ProvideQuoteModal.vue";

const storage_url = import.meta.env.VITE_APP_FILE_URL;
const app_environment = import.meta.env.VITE_APP_NODE_ENV;
const changeFactoryModal = ref<boolean>(false);
const provideQuoteModal = ref<boolean>(false);
const priceBreakdownModal = ref<boolean>(false);
const customTechpackModal = ref<boolean>(false);

const emits = defineEmits(["onFetch"]);
defineProps<{ order_item: any; currentTab: string }>();
const { loading } = storeToRefs(useMainStore());
const appURL = import.meta.env.VITE_VUE2_APP_URL;
const {
  deleteOrder: DeleteFromStore,
  notifyCustomerForQuote,
  updateOrderUrgency,
} = useMainStore();
// const navgivateToApplication = (
//   path: string,
//   newTab: boolean = false,
// ): void => {
//   openV2Application(
//     {
//       name: "",
//       to: path,
//     },
//     newTab,
//   );
// };
type Urgency = "vip" | "urgent" | "extra_attention";

const updateUrgency = async (status: Urgency, orderId: number | string) => {
  await updateOrderUrgency(status, orderId);
  emits("onFetch", true);
};

const onFetch = (fetch: boolean) => {
  changeFactoryModal.value = false;
  provideQuoteModal.value = false;
  emits("onFetch", fetch);
};
const deleteOrder = async (orderId: number): Promise<void> => {
  await DeleteFromStore(orderId);
  emits("onFetch", true);
};

const handlePriceBreakDownModalCloseEvent = (fetch_order_items = false) => {
  priceBreakdownModal.value = false;
  if (fetch_order_items) {
    emits("onFetch", fetch);
  }
};

const fetchAndOpenPdf = async (order, version_id) => {
  try {
    let order_id = order.id;
    let techpack_data_length = order.techpack_data
      ? order.techpack_data.length
      : 0;
    loading.value = true;
    const response = await http.get(
      `/techpackpdf/order/${order_id}/version/${version_id}`,
    );
    loading.value = false;
    const pdfUrl = response.data.result.pdf_url;
    if (pdfUrl) {
      window.open(`${storage_url}/${pdfUrl}`, "_blank");
    } else {
      if (techpack_data_length) {
        openV2Application(
          {
            name: "",
            to: `/order/${order_id}/condensend-pdf?techpack_version=${version_id}`,
          },
          true,
        );
      } else {
        openV2Application(
          { name: "", to: `/order/${order_id}/condensend-pdf` },
          true,
        );
      }
    }
  } catch (error) {
    logError("Error fetching the PDF URL:", error);
  }
};
</script>
<style lang="scss" scoped></style>
